import { BaseOption } from './MultiSelectField.types';

export const SELECT_ALL_OPTION_VALUE = 'all';

export const isSelectAll = ({ value }: BaseOption) =>
  value === SELECT_ALL_OPTION_VALUE;

export const isNotSelectAll = ({ value }: BaseOption) =>
  value !== SELECT_ALL_OPTION_VALUE;
